/* ===========================================================================
 * qb-tracking.js — Qi Blanco USA · Klick-ID -> Cart-Attribute (Fehler 1 + 4)
 * ---------------------------------------------------------------------------
 * ZWECK  Schreibt die von qb-click-capture.liquid persistierten Marketing-Keys
 *        per /cart/update.js als CART-ATTRIBUTE. Shopify uebertraegt Cart-
 *        Attribute automatisch in die note_attributes der Order (derselbe
 *        Mechanismus, ueber den Gorgias hier nachweislich guest_id/session_id
 *        schreibt). Damit erreichen fbclid/_fbc/gclid die Order -> Hyros + CAPI.
 *
 * EINBAU  In layout/theme.liquid kurz vor dem schliessenden body-Tag
 *         (nach qb-click-capture):
 *             {{ 'qb-tracking.js' | asset_url | script_tag }}
 *
 * REGELN  * bricht NIE die Seite (alles try/catch, fail-silent)
 *         * idempotent: schreibt pro Session nur, wenn sich Werte aendern
 *         * fasst gorgias.* / language NICHT an  (nur eigene Marketing-Keys)
 *         * ES5, lib-frei -> laeuft in alten In-App-Browsern
 *         * additiv: keinerlei Eingriff in Layout/Checkout/Add-to-Cart-Funktion
 * =========================================================================== */
(function () {
  "use strict";
  try {
    var STORE_KEY = "qb_click";
    var DONE_KEY = "qb_attr_written";   // sessionStorage-Marker (Hash der Werte)

    // nur diese Keys wandern als Cart-Attribute in die Order:
    var ATTR_KEYS = [
      "fbclid", "_fbc", "_fbp",
      "gclid", "gbraid", "wbraid",
      "msclkid", "ttclid", "li_fat_id", "epik",
      // X / Snap / Impact / Reddit. qb-click-capture ERFASST diese vier seit
      // jeher im qb_click-Store — sie standen nur nie hier und starben damit an
      // der Cart-Grenze. Das ist dieselbe Fehlerklasse wie _qpx_anon (erfasst,
      // nie durchgereicht), nur fuer vier weitere Plattformen. Der DACH-Shop
      // reicht alle vier durch (checkout-tracking.js TRACKING_PARAM_NAMES, 21
      // Keys, gemessen 2026-08-08) — USA fiel hier still zurueck.
      // Gefunden von tracking-paritaet (Fall `leck`); linkage-check war dafuer
      // baulich blind, weil seine Quellmenge gesetzte COOKIES sind und diese
      // vier reine URL-Parameter im localStorage-Store sind.
      "twclid", "sccid", "irclickid", "rdt_cid",
      "utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term",
      // adset_id gehoert zur selben Struktur-Ebene wie campaign_id/ad_id und
      // wurde ebenfalls erfasst, aber nie durchgereicht.
      "campaign_id", "ad_id", "adset_id",
      // First-Party Anon-/Session-Key (qb-qpx.js setzt ihn als 365-Tage-Cookie).
      // Reist er als Order-note_attribute mit, kann das Backend (own_source,
      // OS_STITCH_SESSION) einen Kauf ueber _qpx_anon -> identity_edge(anon) der
      // Ad-Klick-Session zuordnen — AUCH fuer Return-Visitor OHNE frische
      // Klick-ID. Ohne diesen Key kollabiert genau dieser Fall zu "direct"
      // (Root-Cause DACH 2026-07, hier fuer USA geschlossen).
      "_qpx_anon",
      // First-Touch-Kontext (Job 20260807-utm-attributions-setup s04, 2026-08-08).
      // qb-click-capture legt beide seit jeher im qb_click-Store ab (_ref =
      // document.referrer, _land = pathname+search) — sie hatten nur nie einen Weg
      // ueber die Checkout-Grenze. Der DACH-Storefront reicht die Gegenstuecke
      // durch (checkout-tracking.js: landing_page + referrer als Cart-Attribut),
      // der USA-Shop nicht: an 22 echten USA-Orders gemessen 0x landing_page,
      // 0x referrer. Folge im Backend (gemessen, nicht hergeleitet):
      // own_source._order_landing_touchpoint gibt ohne params/referrer/landing
      // None zurueck = Zero-Touch, und build verbucht den Kauf als "direct" —
      // auch bei perfekt getaggtem Link. Shopifys Ersatzfeld order.landing_site
      // deckt das NICHT ab: bei genau den USA-Orders MIT Marketing-Keys war es
      // durchweg None (gesetzt nur in 4 von 22).
      "_ref", "_land"
    ];

    // Store-Schluessel -> NAME DES CART-ATTRIBUTS. Der Storefront darf hier nicht
    // seine eigene Schreibweise durchreichen: das Backend liest namentlich
    // na["referrer"] und na["landing_page"] (own_source.py _landing_params +
    // _order_landing_touchpoint, herkunft.py:482). Unter "_ref"/"_land" kaemen die
    // Werte zwar bis in die note_attributes, wuerden dort aber von niemandem
    // gelesen — dieselbe Fehlerklasse wie der _qpx_anon-Bug an der DACH-Grenze
    // (Key kommt an, steht in keiner Allowlist des Lesers = still verloren).
    var ATTR_ALIAS = { "_ref": "referrer", "_land": "landing_page" };

    function read(name) {
      try { var s = JSON.parse(name || "{}"); return s && typeof s === "object" ? s : {}; }
      catch (e) { return {}; }
    }
    function getStore() {
      if (window.__qbClick && typeof window.__qbClick === "object") return window.__qbClick;
      try { return read(localStorage.getItem(STORE_KEY)); } catch (e) { return {}; }
    }
    // _qpx_anon lebt NICHT im qb_click-Store, sondern als eigener First-Party-
    // Cookie (qb-qpx.js) bzw. localStorage-Spiegel. Hier robust auslesen.
    function readCookie(name) {
      try {
        var m = document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)");
        return m ? decodeURIComponent(m.pop()) : "";
      } catch (e) { return ""; }
    }
    function qpxAnon() {
      var v = readCookie("_qpx_anon");
      if (!v) { try { v = localStorage.getItem("_qpx_anon") || ""; } catch (e) { v = ""; } }
      return v;
    }

    function buildAttrs(store) {
      var attrs = {};
      for (var i = 0; i < ATTR_KEYS.length; i++) {
        var k = ATTR_KEYS[i];
        if (store[k]) attrs[ATTR_ALIAS[k] || k] = String(store[k]);
      }
      // _land liegt im Store als pathname+search, ohne Host. Das Backend gewinnt
      // daraus zwar die utm-Query (urlsplit().query greift auch auf "/x?a=1"),
      // verliert aber den Host: tracked_host wird None statt "qi-blanco.com"
      // (beide Varianten gegen own_source durchgemessen). Absolut machen — der
      // qb_click-Store ist origin-gebunden, location.origin ist derselbe Origin,
      // unter dem _land entstanden ist. location.origin fehlt in ganz alten
      // In-App-Browsern, darum der protocol+host-Rueckfall.
      try {
        if (attrs.landing_page && attrs.landing_page.charAt(0) === "/") {
          var origin = location.origin || (location.protocol + "//" + location.host);
          if (origin) attrs.landing_page = origin + attrs.landing_page;
        }
      } catch (e) { /* fail-silent: lieber der rohe Pfad als gar kein Wert */ }
      return attrs;
    }

    // referrer/landing_page sind KONTEXT, kein eigenes Herkunfts-Signal. Der DACH-
    // Storefront haengt seine Gegenstuecke nur an, wenn schon mindestens ein
    // Tracking-Signal im Warenkorb steht (checkout-tracking.js:
    // "if (!attributes.length) return attributes"). Ohne dieselbe Klammer wuerde
    // _land bei JEDEM Besucher ein Attribut erzeugen: der Kauf bliebe zwar korrekt
    // "direct", aber own_source legte fuer echte Direktkaeufe neu einen
    // order-landing-Touchpoint an, wo bisher Zero-Touch stand — eine stille
    // Mengenverschiebung in journey.db, die kein Kanal-Zaehler als Fehler sieht.
    // Den Referrer-only-Fall (Blog-Link ohne utm) deckt in der Praxis _qpx_anon ab:
    // der 365-Tage-Cookie liegt vor und zaehlt als Signal.
    // INSTRUMENTIERUNGS-MARKER (Job 20260808-us-shop-checkout-linkage-qpx-anon-
    // durchreichen). Er sagt NICHT "der Kauf kam von einer Anzeige", sondern
    // "diese Order lief ueber die instrumentierte Kasse" — er ist bewusst
    // ad-UNABHAENGIG. Genau darauf misst `shop-ankunft` Gate B: solange KEINE
    // einzige US-Order ihn traegt, ist "der Shop ist gar nicht instrumentiert"
    // nicht von "es kamen halt keine Ad-Kaeufer" unterscheidbar. Am 2026-08-08
    // gemessen: 22 Orders, 28.780 Pixel-Events, Marker 0x -> INSTRUMENTIERUNG_FEHLT.
    // Das DACH-Gegenstueck heisst `qiblanco_hydrogen` (checkout-tracking.js).
    var MARKER_KEY = "attribution_source";
    var MARKER_WERT = "qiblanco_us_liquid";

    // referrer/landing_page sind KONTEXT, kein eigenes Herkunfts-Signal. Der DACH-
    // Storefront haengt seine Gegenstuecke nur an, wenn schon mindestens ein
    // Tracking-Signal im Warenkorb steht (checkout-tracking.js:
    // "if (!attributes.length) return attributes"). Ohne dieselbe Klammer wuerde
    // _land bei JEDEM Besucher ein Attribut erzeugen: der Kauf bliebe zwar korrekt
    // "direct", aber own_source legte fuer echte Direktkaeufe neu einen
    // order-landing-Touchpoint an, wo bisher Zero-Touch stand — eine stille
    // Mengenverschiebung in journey.db, die kein Kanal-Zaehler als Fehler sieht.
    // Den Referrer-only-Fall (Blog-Link ohne utm) deckt in der Praxis _qpx_anon ab:
    // der 365-Tage-Cookie liegt vor und zaehlt als Signal.
    // DER MARKER STEHT MIT IN DIESER LISTE, und das ist der Kern des Entwurfs:
    // er wird IMMER geschrieben, darf aber selbst NIE als Signal gelten. Zaehlte
    // er als Signal, haenge ab sofort bei JEDEM Besucher landing_page/referrer mit
    // dran — genau die Mengenverschiebung, die der Absatz darueber verhindert.
    // consent_state steht aus demselben Grund mit drin: er ist ein Zustand des
    // Browsers, kein Herkunfts-Signal, und geht bei jedem Besucher mit.
    var CONTEXT_ONLY = { "referrer": 1, "landing_page": 1, "attribution_source": 1, "consent_state": 1 };
    // Diese beiden gehen IMMER mit, auch ohne Herkunfts-Signal.
    var ALWAYS = { "attribution_source": 1, "consent_state": 1 };

    // EINWILLIGUNGS-MARKER (Job 20261007-ep-us-laden-fbp-und-einwilligung-an-
    // bestellung). Der rohe Cookiebot-Marketing-Stempel als drei Werte, wie der
    // DACH-Laden ihn schreibt (checkout-tracking.js consentStateFromCookies):
    // granted | denied | unknown. Er ist NICHT das Urteil "durfte getrackt
    // werden" - in den USA (Opt-out) bleibt er ohne Entscheidung 'unknown'.
    // Leser ist capi-rueckspeisung/src/einwilligung.py: 'denied' am Auftrag
    // sperrt jeden Send an Meta/Google, in jedem Markt. Bis hierher schrieb der
    // US-Laden keinen solchen Marker, eine Ablehnung war an der US-Bestellung
    // unsichtbar. Gelesen wird zuerst das geladene Cookiebot-Objekt (nur wenn
    // es eine Entscheidung kennt), sonst das CookieConsent-Cookie; das Muster
    // ist das DACH-Muster und versteht quotierte wie unquotierte Schluessel.
    function consentState() {
      try {
        var C = window.Cookiebot;
        if (C && C.hasResponse && C.consent) return C.consent.marketing ? "granted" : "denied";
      } catch (e) {}
      var raw = readCookie("CookieConsent");
      if (!raw) return "unknown";
      if (/(?:^|[,{]\s*|["'])marketing["']?\s*:\s*true(?:[,}]|$)/i.test(raw)) return "granted";
      if (/(?:^|[,{]\s*|["'])marketing["']?\s*:\s*false(?:[,}]|$)/i.test(raw)) return "denied";
      return "unknown";
    }
    function hasSignal(attrs) {
      for (var k in attrs) {
        if (attrs.hasOwnProperty(k) && !CONTEXT_ONLY[k]) return true;
      }
      return false;
    }

    function signature(attrs) {
      // stabile Signatur, um Doppelschreiben zu vermeiden
      var keys = []; for (var k in attrs) { if (attrs.hasOwnProperty(k)) keys.push(k + "=" + attrs[k]); }
      keys.sort();
      return keys.join("|");
    }

    // WARENKORB-WECHSEL (gemessen 2026-10-07 im Live-Laden): beim Erstbesuch gibt
    // es noch keinen cart-Cookie. Unser POST und der language-POST von Langify
    // laufen dann gleichzeitig, Shopify legt ZWEI Warenkoerbe an, und der
    // Cookie zeigt danach auf den fremden. Der alte Marker hiess trotzdem
    // "geschrieben", und weil die Signatur gleich blieb, schrieb auch kein
    // Add-to-Cart nach: die Bestellung kam ohne jedes eigene Attribut an
    // (Signatur der US-Orders #2192 und #2196: nur 'language'). Der Marker merkt
    // sich deshalb auch, IN WELCHEN Warenkorb geschrieben wurde.
    function cartBase(tok) { return String(tok || "").split("?")[0]; }
    function cartToken() { return cartBase(readCookie("cart")); }
    function alreadyWritten(sig) {
      try {
        var tok = cartToken();
        return !!tok && sessionStorage.getItem(DONE_KEY) === sig + "#" + tok;
      } catch (e) { return false; }
    }
    function markWritten(sig, tok) {
      try { sessionStorage.setItem(DONE_KEY, sig + "#" + cartBase(tok)); } catch (e) {}
    }
    var nachschreiben = 0;   // Deckel fuer den Wechsel-Rueckfall je Seite

    function writeAttrs() {
      try {
        var store = getStore() || {};
        var attrs = buildAttrs(store);
        // _qpx_anon additiv aus eigenem Cookie/localStorage nachziehen (lebt
        // NICHT im qb_click-Store). WICHTIG fuer den Return-Visitor-Fall: dann
        // ist der Klick-Store leer, aber der _qpx_anon-Cookie existiert — genau
        // dieser Kauf soll ueber die Session gestitcht werden. Vorhandenen Wert
        // nie ueberschreiben.
        if (!attrs._qpx_anon) {
          var qa = qpxAnon();
          if (qa) attrs._qpx_anon = String(qa);
        }
        // _fbp/_fbc setzt das Meta-Pixel (Shopify-Web-Pixels-Manager) ERST nach
        // dem <head> — qb-click-capture laeuft aber als ALLERERSTES im <head>.
        // Beim ERSTbesucher ist der Cookie dort also noch gar nicht da, und der
        // Store bleibt leer: an 22 US-Orders gemessen trugen nur 3 ein _fbp.
        // Zum Schreibzeitpunkt (DOMContentLoaded/nach Add-to-Cart) existiert er.
        // Gleiche Mechanik, die _qpx_anon oben schon rettet — vorhandene
        // Store-Werte werden nie ueberschrieben (First-Touch gewinnt).
        if (!attrs._fbp) { var fbp = readCookie("_fbp"); if (fbp) attrs._fbp = String(fbp); }
        if (!attrs._fbc) { var fbc = readCookie("_fbc"); if (fbc) attrs._fbc = String(fbc); }

        // Marker IMMER setzen — er ist der ad-unabhaengige Beleg, dass diese
        // Order ueber die instrumentierte Kasse lief.
        attrs[MARKER_KEY] = MARKER_WERT;
        attrs.consent_state = consentState();

        // Ohne echtes Herkunfts-Signal geht NUR der Marker raus: der Kontext
        // (landing_page/referrer) bleibt draussen, damit own_source fuer echte
        // Direktkaeufe weiterhin Zero-Touch sieht statt eines neuen
        // order-landing-Touchpoints (s04-Entscheid, oben begruendet).
        // Frueher stieg die Funktion hier komplett aus — deshalb trug NIE eine
        // signal-lose Order irgendein Attribut, und Gate B konnte nicht kippen.
        if (!hasSignal(attrs)) {
          for (var ck in CONTEXT_ONLY) {
            if (CONTEXT_ONLY.hasOwnProperty(ck) && !ALWAYS[ck]) delete attrs[ck];
          }
        }
        var sig = signature(attrs);
        if (!sig || alreadyWritten(sig)) return;          // nichts (Neues) zu schreiben
        if (typeof fetch !== "function") return;          // uralt-Engine: still aussteigen

        fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ attributes: attrs }),
          credentials: "same-origin",
          keepalive: true
        }).then(function (r) { return r && r.ok ? r.json() : null; })
          .then(function (cart) {
            if (!cart || !cart.token) return;
            markWritten(sig, cart.token);
            // Hat ein paralleler Erst-POST den Cookie auf einen anderen Warenkorb
            // gesetzt, steht unser Satz im falschen. Kurz warten, dann in den
            // Warenkorb schreiben, auf den der Cookie jetzt zeigt.
            setTimeout(function () {
              try {
                var jetzt = cartToken();
                if (jetzt && jetzt !== cartBase(cart.token) && nachschreiben < 2) {
                  nachschreiben++;
                  writeAttrs();
                }
              } catch (e) {}
            }, 1500);
          })
          .catch(function () { /* fail-silent: Tracking darf den Shop nie stoeren */ });
      } catch (e) { /* fail-silent */ }
    }

    // 1) einmal beim Laden (Cart-Attribute persistieren auch auf leerem Warenkorb)
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", writeAttrs);
    } else {
      writeAttrs();
    }

    //    Nach dem Laden noch einmal: der Meta-App-Pixel setzt _fbp oft erst nach
    //    DOMContentLoaded. Gleiche Werte im selben Warenkorb = kein Request.
    try {
      window.addEventListener("load", function () { setTimeout(writeAttrs, 2500); });
    } catch (e) {}

    //    Und wenn der Besucher im Cookiebot-Banner entscheidet: consent_state
    //    soll den neuen Stand tragen, nicht den beim Seitenaufbau.
    try {
      var CB_EVENTS = ["CookiebotOnAccept", "CookiebotOnDecline", "CookiebotOnConsentReady"];
      for (var ci = 0; ci < CB_EVENTS.length; ci++) {
        window.addEventListener(CB_EVENTS[ci], function () { setTimeout(writeAttrs, 50); });
      }
    } catch (e) {}

    // 2) nach jedem Add-to-Cart erneut sicherstellen (Theme- und AJAX-Adds)
    //    a) klassische <form action="/cart/add"> Submits
    document.addEventListener("submit", function (ev) {
      try {
        var f = ev.target;
        if (f && f.action && /\/cart\/add/.test(f.action)) {
          setTimeout(writeAttrs, 400);
        }
      } catch (e) {}
    }, true);

    //    b) AJAX-Adds: /cart/add.js abfangen, ohne das Original zu veraendern
    try {
      if (typeof window.fetch === "function" && !window.__qbFetchPatched) {
        window.__qbFetchPatched = true;
        var _origFetch = window.fetch;
        window.fetch = function (input, init) {
          var url = "";
          try { url = (typeof input === "string") ? input : (input && input.url) || ""; } catch (e) {}
          var p = _origFetch.apply(this, arguments);
          try {
            if (/\/cart\/add(\.js)?/.test(url)) { p.then(function () { setTimeout(writeAttrs, 250); }); }
          } catch (e) {}
          return p;   // Original-Promise unveraendert zurueck -> Add-to-Cart bleibt 1:1
        };
      }
    } catch (e) {}
  } catch (e) { /* niemals die Seite brechen */ }
})();
